module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/model/model.component.scss
// module id = ./client/app/model/model.component.scss
// module chunks = main